module.exports = __webpack_public_path__ + "static/media/ic_cockpit.648e5919.svg";